import { DeviceBreakpointsType } from '@kubit/web-ui-components/types/breakpoints';
import { buildMediumIconSize } from './iconButton/sizes/medium';
import { buildSmallIconSize } from './iconButton/sizes/small';
import { getIconMainSectionStyles } from './variantStyles/iconMainSection';
import { getIconPrimaryStyles } from './variantStyles/iconPrimary';
import { getIconPrimaryContactCenterStyles } from './variantStyles/iconPrimaryContactCenter';
import { getIconPrimaryFilledStyles } from './variantStyles/iconPrimaryFilled';
import { getIconPrimaryOnSurfaceStyles } from './variantStyles/iconPrimaryOnSurface';
import { getIconSecondaryStyles } from './variantStyles/iconSecondary';
import { getIconSecondaryContactCenterStyles } from './variantStyles/iconSecondaryContactCenter';
import { getIconSecondaryFilledStyles } from './variantStyles/iconSecondaryFilled';
import { getIconSecondaryMainSectionStyles } from './variantStyles/iconSecondaryMainSection';
import { getIconSecondaryOnSurfaceStyles } from './variantStyles/iconSecondaryOnSurface';
import { getMainSectionHeaderGhostStyles } from './variantStyles/mainSectionHeaderGhost';
import { getPrimaryStyles } from './variantStyles/primary';
import { getPrimaryContactCenterStyles } from './variantStyles/primaryContactCenter';
import { getPrimaryExpandedStyles } from './variantStyles/primaryExpanded';
import { getPrimaryGhostStyles } from './variantStyles/primaryGhost';
import { getPrimaryGhostContactCenterStyles } from './variantStyles/primaryGhostContactCenter';
import { getSecondaryStyles } from './variantStyles/secondary';
import { getSecondaryContactCenterStyles } from './variantStyles/secondaryContactCenter';
import { getSecondaryGhostStyles } from './variantStyles/secondaryGhost';
import { getSecondaryOnSurfaceStyles } from './variantStyles/secondaryOnSurface';
import { getSecondaryOnSurfaceGhostStyles } from './variantStyles/secondaryOnSurfaceGhost';
import { ButtonSizeType } from './variants';
export const getButtonStyles = (FOUNDATIONS, FONT) => {
    return {
        [ButtonSizeType.LARGE]: {
            padding: `${FOUNDATIONS.spacing_200} ${FOUNDATIONS.spacing_250}`,
            font_size: FONT.font_paragraph_250[DeviceBreakpointsType.DESKTOP].font_size,
            line_height: FONT.font_paragraph_250[DeviceBreakpointsType.DESKTOP].line_height,
        },
        [ButtonSizeType.SMALL]: {
            padding: `${FOUNDATIONS.spacing_100} ${FOUNDATIONS.spacing_250}`,
            font_size: FONT.font_paragraph_400[DeviceBreakpointsType.DESKTOP].font_size,
            line_height: FONT.font_paragraph_400[DeviceBreakpointsType.DESKTOP].line_height,
        },
        [ButtonSizeType.ICON_MEDIUM]: buildMediumIconSize(FOUNDATIONS),
        [ButtonSizeType.ICON_SMALL]: buildSmallIconSize(FOUNDATIONS),
        [ButtonSizeType.EXTRA_SMALL]: {
            padding: `${FOUNDATIONS.spacing_50} ${FOUNDATIONS.spacing_50}`,
            font_size: FONT.link_font_paragraph_400[DeviceBreakpointsType.DESKTOP].font_size,
            line_height: FONT.link_font_paragraph_400[DeviceBreakpointsType.DESKTOP].line_height,
            icon: {
                height: FOUNDATIONS.size_250,
                width: FOUNDATIONS.size_250,
            },
        },
        ...getIconMainSectionStyles(FOUNDATIONS, FONT),
        ...getIconPrimaryStyles(FOUNDATIONS, FONT),
        ...getIconPrimaryContactCenterStyles(FOUNDATIONS, FONT),
        ...getIconPrimaryFilledStyles(FOUNDATIONS, FONT),
        ...getIconPrimaryOnSurfaceStyles(FOUNDATIONS, FONT),
        ...getIconSecondaryStyles(FOUNDATIONS, FONT),
        ...getIconSecondaryContactCenterStyles(FOUNDATIONS, FONT),
        ...getIconSecondaryFilledStyles(FOUNDATIONS, FONT),
        ...getIconSecondaryMainSectionStyles(FOUNDATIONS, FONT),
        ...getIconSecondaryOnSurfaceStyles(FOUNDATIONS, FONT),
        ...getMainSectionHeaderGhostStyles(FOUNDATIONS, FONT),
        ...getPrimaryStyles(FOUNDATIONS, FONT),
        ...getPrimaryExpandedStyles(FOUNDATIONS, FONT),
        ...getPrimaryContactCenterStyles(FOUNDATIONS, FONT),
        ...getPrimaryGhostStyles(FOUNDATIONS, FONT),
        ...getPrimaryGhostContactCenterStyles(FOUNDATIONS, FONT),
        ...getSecondaryStyles(FOUNDATIONS, FONT),
        ...getSecondaryContactCenterStyles(FOUNDATIONS, FONT),
        ...getSecondaryGhostStyles(FOUNDATIONS, FONT),
        ...getSecondaryOnSurfaceStyles(FOUNDATIONS, FONT),
        ...getSecondaryOnSurfaceGhostStyles(FOUNDATIONS, FONT),
    };
};
//# sourceMappingURL=styles.js.map